import React from 'react';
import { Platform } from 'react-native';
// import { AsyncStorage } from 'common/widget/Community';
// import ypm from 'utils/spm';
/* global CommonBridgeModule process */
import Cookie from 'common/Cookie';
import { IMG_BASE_URL } from 'base/services/config.web';
// import Constants from './Constants';

const CommonBridge = {
  SDK_INT: 0,
  StatusBarHeight: 0,
  PackageName: 0,
  OsName: 0,
  OsVersion: 0,
  AppVersion: 0,
  AppVersionCode: 0,
  DeviceModel: 0,
  isSupportPullRefresh: () => false,
  DeviceId: 0,
  OAID: '',
  CUSTOM_OSVERSION: 'unknown',
  isIOS: () => Platform.OS === 'ios',
  isWeb: () => true,
  isAndroid: () => Platform.OS === 'android',
  BundlePath: IMG_BASE_URL,
  isMiuinewapp() {
    const miuinewapp = /miui\.hybrid/.test(window.navigator.userAgent);
    return miuinewapp;
  },
  isWxminiprogram() {
    // 微信小程序
    const uaText = navigator.userAgent;
    return (
      window.__wxjs_environment === 'miniprogram' ||
      /^wechatdevtools/.test(uaText) ||
      (uaText.match(/MicroMessenger/i) && uaText.match(/miniProgram/i))
    );
  },
  /**
   * 拦截IOS右划返回手势，在RN中声明
   */
  interceptIOSSwipeBack() {},
  isZhifubaoMini() {
    // 支付宝小程序
    const uaText = navigator.userAgent;
    return /AliApp|AlipayClient/i.test(uaText);
  },
  isToutiaominiProgram() {
    const toutiaominiProgram = /toutiaomicroapp/.test(window.navigator.userAgent.toLocaleLowerCase());
    return toutiaominiProgram;
  },
  AppKey: '',
  UserAgent: '',
  BrowserUserAgent: '',
  isStaging() {
    return (
      location.hostname.startsWith('m.test.') ||
      location.hostname.startsWith('st.') ||
      location.hostname.startsWith('trade.m.st') ||
      location.hostname.startsWith('trade.st') ||
      location.hostname.startsWith(`${DevModeWebPrefix}.st.`) ||
      location.hostname.startsWith(`${DevModeWebPrefix}.trade.m.st.`)
    );
  },
  isPopShowed() {
    return new Promise((resolve) => {
      resolve('canshow');
    });
  },
  notifyDataChanged() {},
  openWebPage() {
    console.warn('该方法目前之在native实现');
  },
  isTablet() {
    return window.YouPin_stat.os.isTablet;
  },
  isYoupinApp() {
    // 非有品APP
    return false;
  },
  isMJYPApp() {
    // 非米家和有品APP
    return false;
  },
  isMJApp() {
    // 非米家和有品APP
    return false;
  },
  isSafari() {
    if (CommonBridge.isWeb()) {
      const ua = navigator.userAgent;
      return /Safari/.test(ua) && !/Chrome/.test(ua);
    }
    return false;
  },
  getSource() {
    return new Promise((resolve) => {
      resolve(Cookie.getCookie('mijiasn', 'mi.com') || 'm');
    });
    // return Cookie.getCookie('mijiasn', 'mi.com') || 'm';
  },
  init() {},
  isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  rh_resetDensity: async () => {},
  has_rh_resetDensity: () => false,
  fireGlobalEventForName(name, params) {},
  back(instance, callback) {},
  backN(n, callback) {},
  finishAndOpenUrl({ url, animate }, callback) {},
  getUserId() {
    return '';
  },
  getUserAddress() {
    return null;
  },
  setUserAddress() {
    return null;
  },
  getCommonInfo() {
    return {};
  },
  getRNInfo(callback) {
    return {};
  },
  getHttpHeaders() {
    return {};
  },
  isMishop: () => {
    return process.env.APPCHANNEL === 'mishop';
  },
  isMishopApp() {
    return false;
  },
  async getEnvStatus() {
    if (location.href.indexOf('st.') > -1 || location.href.indexOf('test.') > -1) {
      return 2;
    }
    return 0;
  },
  // 0-线上 1-测试 2-预发
  // 和RN保持一致
  async getNormalEnvStatus() {
    if (location.href.indexOf('st.') > -1 || location.href.indexOf('test.') > -1) {
      return 1;
    } else if (location.href.indexOf('pre.') > -1) {
      return 2;
    }
    return 0;
  },
  hasAnomalousBar(cb) {
    cb(0, false, {});
  },
  rh_checkPermission: (data, callback) => {
    callback();
  },
  rh_checkPrivacyAgreement: () => {},
  rh_checkFloatingLiveWindow: () => {},
  rh_urlSetStatusBar: (param, callback) => {},
  rh_starBarModel: (param, callback) => {},
  setUserAddress: () => {},
};

const MessageBridge = {
  getChatList() {},
};

export default CommonBridge;
export { MessageBridge };
